import React, { useState, useEffect, useContext } from 'react';
import AddTable from "./AddTable";
import AddSelfTake from "./AddSelfTake";
import FinalCheckout from "./FinalCheckout";
import LocationPicker from "./LocationPicker";
import { LocalizationContext } from '../../localization/LocalizationContext';
import '../../css/FinalCheckout.css';
import '../../css/AddDelivery.css';

const isFastDeliveryDomain = () => {
    const hostname = window.location.hostname;
    return hostname === 'fastdelivery.ge' || hostname === 'www.fastdelivery.ge';
};

const DeliveryWay = ({ totalPrice, selectedProducts, productQuantities, onBack }) => {
    const [deliveryMethod, setDeliveryMethod] = useState('Delivery');
    const [isFastDelivery, setIsFastDelivery] = useState(false);
    const [confirmedLocation, setConfirmedLocation] = useState(null);
    const { translations } = useContext(LocalizationContext);

    useEffect(() => {
        const isFastDel = isFastDeliveryDomain();
        setIsFastDelivery(isFastDel);

        try {
            const saved = localStorage.getItem('confirmedDeliveryAddress');
            if (saved) {
                const parsed = JSON.parse(saved);
                if (parsed?.lat && parsed?.lng && parsed?.address) {
                    setConfirmedLocation(parsed);
                }
            }
        } catch {}

        if (isFastDel) {
            setDeliveryMethod('Delivery');
            return;
        }

        const savedMethod = localStorage.getItem('deliveryOption');
        if (savedMethod === 'dine-in') {
            setDeliveryMethod('At the Table');
        } else if (savedMethod === 'take-away') {
            setDeliveryMethod('Self Pickup');
        } else if (savedMethod === 'delivery') {
            setDeliveryMethod('Delivery');
        }
    }, []);

    const handleDeliveryChange = (method) => {
        setDeliveryMethod(method);
        setConfirmedLocation(null);
    };

    const handleLocationConfirm = (location) => {
        setConfirmedLocation(location);
        localStorage.setItem('confirmedDeliveryAddress', JSON.stringify(location));
    };

    if (deliveryMethod === 'Delivery' && !confirmedLocation) {
        return (
            <LocationPicker
                onConfirm={handleLocationConfirm}
                onBack={onBack}
            />
        );
    }

    if (deliveryMethod === 'Delivery' && confirmedLocation) {
        return (
            <FinalCheckout
                totalPrice={totalPrice}
                selectedProducts={selectedProducts}
                productQuantities={productQuantities}
                confirmedLocation={confirmedLocation}
                onEditAddress={() => setConfirmedLocation(null)}
            />
        );
    }

    const t = translations?.deliveryPage || {};

    return (
        <div className="fc-page">
            <div className="fc-header">
                <button className="fc-back-btn" onClick={onBack}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M15 18l-6-6 6-6" />
                    </svg>
                </button>
                <h1 className="fc-title">{t.ChooseDeliveryMethod || 'Order Details'}</h1>
                <div style={{ width: 40 }} />
            </div>

            {!isFastDelivery && (
                <div className="fc-toggle-group">
                    <button
                        className={`fc-toggle-btn ${deliveryMethod === 'At the Table' ? 'active' : ''}`}
                        onClick={() => handleDeliveryChange('At the Table')}
                    >
                        {t.AtTheTable || 'Table'}
                    </button>
                    <button
                        className={`fc-toggle-btn ${deliveryMethod === 'Delivery' ? 'active' : ''}`}
                        onClick={() => handleDeliveryChange('Delivery')}
                    >
                        {t.FastDelivery || 'Delivery'}
                    </button>
                    <button
                        className={`fc-toggle-btn ${deliveryMethod === 'Self Pickup' ? 'active' : ''}`}
                        onClick={() => handleDeliveryChange('Self Pickup')}
                    >
                        {t.SelfPickup || 'Pickup'}
                    </button>
                </div>
            )}

            <div className="fc-card">
                {deliveryMethod === 'Self Pickup' ? (
                    <AddSelfTake
                        totalPrice={totalPrice}
                        selectedProducts={selectedProducts}
                        productQuantities={productQuantities}
                    />
                ) : (
                    <AddTable
                        totalPrice={totalPrice}
                        selectedProducts={selectedProducts}
                        productQuantities={productQuantities}
                    />
                )}
            </div>
        </div>
    );
};

export default DeliveryWay;
